export const LINE_HEIGHT = 1.32;
export const DEFAULT_ALPHA_BACKGROUND_ITEM = 0.05;
